module.exports = ".activeToolWrapper {\n  background-color: blue; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/active-tool.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/active-tool.component.scss
// module chunks = main